import React, { useState, useEffect, useContext } from 'react'
import {
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CMultiSelect,
  CRow,
} from '@coreui/react-pro'
import { Spinner } from '../spinner/Spinner'
import { createSupplierContact } from 'src/services/requests/supplierContacts/supplierContacts'
import { GlobalVariablesContext } from 'src/contexts/globalVariableContext'

const AddNewSupplierContactModal = ({
  tenderChapter,
  fetchTenderSubChapters,
  t,
  allSuppliersOptions,
  setError,
  addSupplierContactModalVisible,
  setAddSupplierContactModalVisible,
}) => {
  const { fetchAllSuppliersWithContacts } = useContext(GlobalVariablesContext)

  const [isLoading, setIsLoading] = useState(false)
  const [validated, setValidated] = useState(false)

  const [selectedSupplier, setSelectedSupplier] = useState('')

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [preferredLanguage, setPreferredLanguage] = useState('de')
  const [modalSupplierContactData, setModalSupplierContactData] = useState()

  const closeModal = () => {
    setAddSupplierContactModalVisible(false)
    setValidated(false)
    setFirstName('')
    setLastName('')
    setEmail('')
    setPhone('')
    setPreferredLanguage('de')
  }

  const isDisabled =
    selectedSupplier == '' ||
    selectedSupplier.length === 0 ||
    firstName == '' ||
    firstName.length === 0 ||
    lastName == '' ||
    lastName.length === 0 ||
    email == '' ||
    email.length === 0 ||
    phone == '' ||
    phone.length === 0

  useEffect(() => {
    setModalSupplierContactData({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      preferredLanguage: preferredLanguage,
      active: 'active',
    })
  }, [firstName, lastName, email, phone, preferredLanguage])

  const handleSubmit = (event) => {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
      setValidated(true)
    } else {
      event.preventDefault()
      setValidated(true)

      if (isDisabled == false) {
        modalCreateSupplierContact(selectedSupplier, modalSupplierContactData)
      }
    }
  }

  const modalCreateSupplierContact = async (id, data) => {
    return new Promise((resolve) => {
      setIsLoading(true)
      createSupplierContact(id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((exception) => {
          // setErrorMsg(error.response.data.error)
          setError(exception?.response?.data?.error)
        })
        .finally(() => {
          fetchAllSuppliersWithContacts()
          fetchTenderSubChapters(tenderChapter)
          setIsLoading(false)
          closeModal()
        })
    })
  }

  return (
    <>
      <CModal
        backdrop='static'
        alignment='center'
        visible={addSupplierContactModalVisible}
        onClose={() => closeModal()}
        aria-labelledby='Add Supplier Contact Modal'
      >
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle id='addSupplierModal'>
            {t('AddSupplierCotactModal.title.AddSupplierContact')}
          </CModalTitle>
        </CModalHeader>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CModalBody>
            <Spinner pageLoading={isLoading}>
              <CRow>
                <CCol md={12} className='mb-4 pb-4 border-bottom'>
                  <CMultiSelect
                    clearSearchOnSelect
                    virtualScroller
                    allowCreateOptions
                    label={t('SelectSupplier')}
                    placeholder={t('SupplierContacts')}
                    searchNoResultsLabel={t('NoResultsFound')}
                    selectAllLabel={t('SelectAllLabel')}
                    multiple={false}
                    options={allSuppliersOptions}
                    onChange={(option) => {
                      setSelectedSupplier(option[0].value)
                    }}
                    onHide={() => {
                      setSelectedSupplier('')
                    }}
                  />
                </CCol>
              </CRow>
              {selectedSupplier && (
                <CRow>
                  <CCol md={12} className='mb-2'>
                    <CFormInput
                      required
                      feedbackInvalid={t('FirstNameFeedbackInvalid')}
                      type='text'
                      label={t('FirstName')}
                      placeholder={t('FirstName')}
                      aria-label={t('FirstName')}
                      value={firstName}
                      onInput={(e) => {
                        setFirstName(e.target.value)
                      }}
                    />
                  </CCol>
                  <CCol md={12} className='mb-2'>
                    <CFormInput
                      required
                      feedbackInvalid={t('LastNameFeedbackInvalid')}
                      type='text'
                      label={t('LastName')}
                      placeholder={t('LastName')}
                      aria-label={t('LastName')}
                      value={lastName}
                      onInput={(e) => {
                        setLastName(e.target.value)
                      }}
                    />
                  </CCol>
                  <CCol md={12} className='mb-2'>
                    <CFormInput
                      required
                      feedbackInvalid={t('EmailFeedbackInvalid')}
                      type='email'
                      label={t('Email')}
                      placeholder={t('Email')}
                      aria-label={t('Email')}
                      value={email}
                      onInput={(e) => {
                        setEmail(e.target.value)
                      }}
                    />
                  </CCol>
                  <CCol md={12} className='mb-2'>
                    <CFormInput
                      required
                      feedbackInvalid={t('PhoneFeedbackInvalid')}
                      label={t('Phone')}
                      placeholder={t('Phone')}
                      aria-label={t('Phone')}
                      type='text'
                      value={phone}
                      onInput={(e) => {
                        setPhone(e.target.value)
                      }}
                    />
                  </CCol>
                  <CCol md={12} className='mb-2'>
                    <CFormSelect
                      required
                      feedbackInvalid={t('PreferredLanguageFeedbackInvalid')}
                      label={t('PreferredLanguage')}
                      aria-label={t('PreferredLanguage')}
                      options={[
                        'Select language',
                        { label: 'en', value: 'en' },
                        { label: 'de', value: 'de' },
                        { label: 'fr', value: 'fr' },
                        { label: 'it', value: 'it' }
                      ]}
                      value={preferredLanguage}
                      onChange={(e) => {
                        return setPreferredLanguage(e.target.value)
                      }}
                    />
                  </CCol>
                </CRow>
              )}
            </Spinner>
          </CModalBody>
          <CModalFooter>
            <CButton color='secondary' onClick={() => closeModal()}>
              {t('Close')}
            </CButton>
            <CButton color='primary' type='submit' disabled={isDisabled}>
              {t('AddSupplierContactModal.button.CreateSupplierContact')}
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}

export default AddNewSupplierContactModal
